module.exports = __webpack_public_path__ + "static/img/good3.a1ee286.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/index/good3.jpg
// module id = 1sx6
// module chunks = 30